import { Box, Grid, Stack } from "@mui/material";
import { useLocation } from "@reach/router";
import { HeadingL, useIsDesktop } from '@repo/ui';
import { AnimatePresence } from "framer-motion";
import { type ComponentType, type FC, type PropsWithChildren } from "react";

import { Title as AdrTitle } from "../../pages/profile/address";
import { Title as AmlTitle } from "../../pages/profile/aml";
import { Title as ChaTitle } from "../../pages/profile/changes";
import { Title as ComTitle } from "../../pages/profile/communication-contract";
import { Title as ConTitle } from "../../pages/profile/contact";
import { Title as PerTitle } from "../../pages/profile/personal-information";

import { LoggedInBar } from "../AppBar/Bars";
import { BottomNavigationDesktopComponent } from "../BottomNavigation";
import { BackLink } from "../Link/InternalLink";
import PageTransition from "../PageTransition";
import { isProfileV2Enabled } from "../../queryHooks";
import { Menu } from "./Menu";

const titleBySubPage: Record<string, ComponentType | string> = {
	"souhlas-s-elektronickou-komunikaci-a-kontraktaci": ComTitle,
	adresy: AdrTitle,
	zmeny: ChaTitle,
	kontakty: ConTitle,
	"ochrana-osobich-udaju": PerTitle,
	"doplneni-identifikace": AmlTitle,
};

export const AppBar: FC = () => <LoggedInBar BottomNavigationComponent={BottomNavigationDesktopComponent} />;


export const ProfileLayout: FC<PropsWithChildren & { isMobileCrossroad: boolean }> = ({ children, isMobileCrossroad }) => {
	const isD = useIsDesktop();
	const { pathname } = useLocation();
	const isProfileV2 = isProfileV2Enabled();

	const entry = Object.entries(titleBySubPage).find(([key]) =>
		pathname.includes(key)
	);

	const Title = entry ? entry[1] : undefined;
	const shouldOffsetContent = isD && isProfileV2 && !Title;

	const content = (
		<Box px={isD ? 0 : 4} pt={shouldOffsetContent ? 7 : 0}>
			{!isD && !isMobileCrossroad && (
				<BackLink mb={5} to="/profil" />
			)}
			{Title && (
				<HeadingL withoutScale>
					{typeof Title === "string" ? Title : <Title />}
				</HeadingL>
			)}
			<Stack spacing={5}>{children}</Stack>
		</Box>
	);

	if (isD)
		return (
			<AnimatePresence exitBeforeEnter>
				<Grid container>
					<Grid item md={5}>
						<Menu />
					</Grid>
					<Grid item md={1} />
					<Grid item md={6}>
						{content}
					</Grid>
				</Grid>
			</AnimatePresence>
		);

	return (
		<PageTransition
			customKey={pathname}
			index={isMobileCrossroad}
		>
			<AnimatePresence exitBeforeEnter>{content}</AnimatePresence>
		</PageTransition>
	);
}

